import { useEffect, useRef } from 'react'

import { useConstant } from './useConstant'

export function useAnimationFrame(callback) {
  const callbackRef = useRef(null)
  const handleRef = useRef(null)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(
    () => () => {
      if (handleRef.current) {
        cancelAnimationFrame(handleRef.current)
      }
    },
    []
  )

  return useConstant(() => [
    () => {
      if (!handleRef.current) {
        handleRef.current = requestAnimationFrame(() => {
          handleRef.current = null
          callbackRef.current?.()
        })
      }
    },
    () => {
      if (handleRef.current) {
        cancelAnimationFrame(handleRef.current)
        handleRef.current = null
      }
    },
  ])
}
